// Actually the State type is abit lying - it can be empty object if the controller is late to initialized.
// The decision was made to go with that inaccuracy to have no checks in most of the app, as everything below root are guarded from empty state.
export const isControllerInitialized = (state) => !!state.baseParams;
//# sourceMappingURL=is-controller-initialized.js.map